var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _filter, _image, _mask, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGxWx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.41 27.977.363.671.36.668h-1.445l.363-.668Zm0 0"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h21v20H15Zm0 0"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 26h5v5h-5Zm0 0"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.492 26.844 1.945 3.61h-3.89Zm0 0"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 25h3v3h-3Zm0 0"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.156 25.277.485.903.488.902h-1.945l.488-.902Zm0 0"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 27h3v3h-3Zm0 0"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.621 34.707h6.047l3.742-5.852 3.719 5.852h6.183l-6.656-9.93 6.38-9.484h-6.048l-3.465 5.465-3.441-5.465h-6.184l6.38 9.539-2.298 3.41.22.406 1.323 2.461h-3.476Zm0 0"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15h21v20H15Zm0 0"
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.656 24.777-3.133-4.02-3.441-5.464h-6.184l6.38 9.539 3.132 4.023 3.719 5.852h6.183Zm0 0"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z"
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAADsUlEQVRoge2WX2iVdRjHP8/7nrHn63kxkboq7EaK6CLwqj9QdFFRTZrLyEVggYShFGJkRMxYjBbRP9GxCytiF5Gs6WpDWS6tZDNb083j5lxzzlmrKCgoyNnZ28V5cxO6Ou8JC97P3Xtznud7fp/n93sgIyMjIyMjIyMjI+N/hv2bPx4TGgcOhlzTEZJfGlK1LCRXFxK+EGI3hgQ7Q+z7EJvIYatC866JcmvlKtn4QuLxTdVc2Siq9jhhjQgaHDsr7LDDemGvCUacuc2CqxxaBF3byq1X8SDxiy8FPIET/SRyjU7QJqxFWKtjKwV3OLZRFNsc+12wwaFa2HZPU7eiQeKBsIprlzl+XuR6hNU6wW2CacfuFPa4wxZRfMOx+wRvO7ZV0CH43OH6smsHFQsxOe0sJ2LRjoiqHyKCk3mCZyMsyGMrIuzpPDRGzD2Wxx6KYFOENUXQEkF7HjqiNPVTn0i8Kwy5/SZn0RmRu9oJOoX1O/a+sHUOdwl73iluEzYjWOtYUdDisFew27F+wfFUaqW+teKfb11M9aQIlzvBdcJ+cewGwTphOxzeE8XmRKF3HWsT7HPoEXzp2BFBwaEgy/22ptw+0s+It0aEnY49Jey8sHqHW4RtdorvCLvgWL2g6NjLgv0OvcL2CIYdhkS8xiEv6C27jfRBwpkIyzvWLexJh63CGpziq8JWO7wurMmhXbBP8EGiUsHhuIgfdOhOrVb6IEFDHlshqHPsEUGzU3xO2FqH7cIaBT0Onwi6EpVOOJwQ8cpkTkpqwc2XMYjNRlDj2HpRbBX2h2OPCkLHXhH0OnwqbK/DgGDUiesES5I5GRL0OZxUmjYqEKQ2gmecYpOwhx3eFNbspbfhoMMuYYMOg4KCiFclKhUchgUDDmPCpi7zrfVntLq0ZrxVWjNst8NHgi8cDqmk0kiiUo3DV4laBcE3jp0STDmckeX6lpbbR/oTmbsnunTN6BbUC+t0+DpRqVZwRTInIw59ggnHxgWTgnMOZ1Oplf5EZvdvxD70+TXjM2FHHY4Kxpz4fsHf36MOo8LGklOYFHzrMC2YDSxXLLuf9EEu1GyBjwWHEpWGSm8Dp5z4bpUGfKFK4xdVgu8cZi7ORpogFVgad0aXrhnDIn5AsDhRadShf4FK0wtC/FqVvn6JCgRpj7BjC1S6N7lyB0vfHBZ22mEiCTElOCco/9//Jypw/R7Iz68ZS5Ir95jgSOltsEmH05o/hR+rK9B3RkZGRkZGRkZGRkbGf4a/AJekCx8bO73dAAAAAElFTkSuQmCC",
    id: "b",
    width: 50,
    height: 50
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "n",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.898 15.293 19.415 19.414-6.657-9.93-3.133-4.02-3.441-5.464Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#d93c78",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h50v50H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.621 15.293h19.691v19.41h-19.69Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.547 26.844h3.89v3.61h-3.89Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.184 25.277h1.945v1.805h-1.945Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.688 27.977h1.445v1.34h-1.445Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.898 15.293h19.41v19.41h-19.41Zm0 0",
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#000",
      fillOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m21.914 22.098 3.113 4.082.383-.602-3.133-4.02Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#005b50",
      fillOpacity: 1
    }
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#n",
    mask: "url(#o)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGxWx);
export default __webpack_public_path__ + "static/media/gxWX.e124425a689bc6a93782ea41b74933d2.svg";
export { ForwardRef as ReactComponent };